import React from 'react';

import { Link } from 'react-router-dom';

import gql from 'graphql-tag';
import { Query } from 'react-apollo';

import Wrap from 'components/Wrap';
import Header from 'components/Header';
import Card from 'components/Card';
import Steps from 'components/Steps';
import Alert from 'components/Alert';
import Loader from 'components/Loader';

const getCurrentSweepstakes = gql`
  {
    contests(active: true) {
      id
      name
      category
      banner
      description
    }
  }
`;

const getWinnersSweepstakes = gql`
  {
    contests(has_winners: true, limit: 3) {
      id
      name
      category
      banner
    }
  }
`;

const Home = () => {
  const stepsRef = React.createRef();

  const scrollToNode = () => {
    window.scrollTo({
      top: stepsRef.current.offsetTop,
      behavior: 'smooth',
    });
  };

  return (
    <>
      <Query query={getCurrentSweepstakes}>
        {({ loading, error, data }) => {
          if (loading) return <Loader />;
          if (error) return <Alert>Erro! {error.message}</Alert>;

          return !data.contests.length ? null : (
            <Wrap>
              <Header img={data.contests[0].banner} />
              {data.contests.map(item => (
                <Card key={item.id} {...item}>
                  <Link to={`sweepstake/${item.id}`} className="button--small">
                    Participar
                  </Link>
                  <button className="button--small" onClick={scrollToNode}>
                    Como Participar
                  </button>
                </Card>
              ))}
            </Wrap>
          );
        }}
      </Query>
      <Query query={getWinnersSweepstakes}>
        {({ loading, error, data }) => {
          if (loading) return <Loader />;
          if (error) return <Alert>Erro! {error.message}</Alert>;

          return !data.contests.length ? null : (
            <Wrap>
              <Header
                title="Conheça os vencedores"
                className="header--highlight"
                subtitle="Descubra quem foram os vencedores dos MEO Passatempos"
                img={data.contests[0].banner}
              />
              {data.contests.map(item => (
                <Card key={item.id} {...item} description="Descobre os vencedores">
                  <Link to={`winners/${item.id}`} className="button--small">
                    Ver vencedores
                  </Link>
                </Card>
              ))}
            </Wrap>
          );
        }}
      </Query>
      <Wrap refProp={stepsRef}>
        <Header title="Como Participar" subtitle="Só os verdadeiros fãs podem chegar ao fim" className="header--highlight-alt" />
        <Steps />
      </Wrap>
    </>
  );
};

export default Home;
